import { ChangeDetectionStrategy, Component, inject, input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NODE_EDIT_TAB_COMPONENT, NodeEditTab, SelectedNodeForEdit } from 'src/app/shared/flow-chart/flow-chart.model';
import { SetFpsNodeData } from '../../../node-edit.type';

@Component({
  selector: 'edit-set-fps',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
  ],
  templateUrl: './edit-set-fps.component.html',
  styleUrl: './edit-set-fps.component.scss',
  providers: [
    {
      provide: NODE_EDIT_TAB_COMPONENT,
      useExisting: EditSetFpsComponent,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditSetFpsComponent implements OnInit, NodeEditTab {
  public selectedNodeForEdit = input<SelectedNodeForEdit<SetFpsNodeData>>();
  public disableForm = input<boolean>(false);

  private readonly fb = inject(UntypedFormBuilder);
  private readonly translateService = inject(TranslateService);

  public form: UntypedFormGroup = this.fb.group({
    name: [this.translateService.instant('FLOW_CHART.NODES.SET_FPS.NAME'), [Validators.required]],
    fps: [null, [Validators.required]],
  })

  public ngOnInit(): void {
    if (this.disableForm()) {
      this.form.disable();
    }

    if (this.selectedNodeForEdit()?.data?.name) {
      this.form.setValue({
        name: this.selectedNodeForEdit().data.name,
        fps: this.selectedNodeForEdit().data.fps,
      })
    }
  }
}
